import { useState, useEffect } from 'react';
import { api } from '../config/api';

export const useLimits = () => {
  const [allLimits, setAllLimits] = useState(null);
    
  const [tokenLimit, setTokenUsage] = useState({
    limit: 0,
    usage: 0,
    isExceeded: false
  });

  const [listsLimit, setListsUsage] = useState({
    limit: 0, 
    usage: 0,
    isExceeded: false
  });

  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchData = async () => {
    try {
      const usageData = await api.getUserUsage();

      setAllLimits(usageData);

      setTokenUsage({
        limit: usageData.find(item => item.name === 'token_limit').limit,
        usage: usageData.find(item => item.name === 'token_limit').used,
        isExceeded: usageData.find(item => item.name === 'token_limit').used >= usageData.find(item => item.name === 'token_limit').limit
      });

      setListsUsage({
        limit: usageData.find(item => item.name === 'lists_limit').limit,
        usage: usageData.find(item => item.name === 'lists_limit').used,
        isExceeded: usageData.find(item => item.name === 'lists_limit').used >= usageData.find(item => item.name === 'lists_limit').limit
      });

    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  const isLimitExceeded = (type) => {
    switch (type) {
      case 'tokens':
        return tokenLimit.isExceeded;
      case 'lists':
        return listsLimit.isExceeded;
      default:
        return false;
    }
  };

  const getRemainingLimit = (type) => {
    switch (type) {
      case 'tokens':
        return Math.max(0, tokenLimit.limit - tokenLimit.usage);
      case 'lists':
        return Math.max(0, listsLimit.limit - listsLimit.usage);
      default:
        return 0;
    }
  };

  return {
    tokenLimit: tokenLimit || { limit: 0, usage: 0, isExceeded: false },
    listsLimit: listsLimit || { limit: 0, usage: 0, isExceeded: false },
    loading,
    error,
    isLimitExceeded,
    getRemainingLimit,
    refreshLimits: fetchData
  };
};